import { useQuery } from '@tanstack/react-query';
import { getFacetValues } from '../providers/productFinderAPI';
import { FacetParams, queryKeys } from './queryKeys';

export const useFacetValues = (facetParams: FacetParams, enabled = true) => {
  return useQuery({
    queryKey: queryKeys.facets(facetParams),
    queryFn: () =>
      getFacetValues(
        facetParams.bearerToken,
        facetParams.currentFilters,
        facetParams.attributeName,
        facetParams.indexNames,
        facetParams.salesOrgDivs,
        facetParams.enabledProductTypes
      ),
    enabled: enabled && !!facetParams.bearerToken && !!facetParams.attributeName && facetParams.indexNames.length > 0,
  });
};
